import _ from 'lodash';
import type { HttpClient } from '@remodeling/base';
import {
  DeleteProcessReviewImageGatewayRequest,
  DeleteProcessReviewImageGatewayResponse,
  GetInteriorReviewDoneListRequest,
  GetInteriorReviewDoneListResponse,
  GetInteriorReviewOpenListRequest,
  GetInteriorReviewOpenListResponse,
  GetProcessReviewWriteInfoGatewayRequest,
  GetProcessReviewWriteInfoGatewayResponse,
  GetSiteReviewWriteInfoGatewayRequest,
  GetSiteReviewWriteInfoGatewayResponse,
  PutProcessReviewWriteInfoGatewayRequest,
  PutSiteReviewWriteInfoGatewayRequest,
} from '../../model';

export class GetInteriorReviewOpenList {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: GetInteriorReviewOpenListRequest) {
    return await this.httpClient.request<GetInteriorReviewOpenListResponse>({
      method: 'GET',
      url: `${process.env.NEXT_PUBLIC_BASE_API_URL}${process.env.NEXT_PUBLIC_GW_PATH_PREFIX}/goods-service/api/v1/goods/interior-evaluations/open`,
      body: req,
    });
  }
}

export class GetInteriorReviewDoneList {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: GetInteriorReviewDoneListRequest) {
    return await this.httpClient.request<GetInteriorReviewDoneListResponse>({
      method: 'GET',
      url: `${process.env.NEXT_PUBLIC_BASE_API_URL}${process.env.NEXT_PUBLIC_GW_PATH_PREFIX}/goods-service/api/v1/goods/interior-evaluations/done`,
      body: req,
    });
  }
}

export class GetProcessReviewWriteInfoGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: GetProcessReviewWriteInfoGatewayRequest) {
    return await this.httpClient.request<GetProcessReviewWriteInfoGatewayResponse>(
      {
        method: 'GET',
        url: `${process.env.NEXT_PUBLIC_BASE_API_URL}${process.env.NEXT_PUBLIC_GW_PATH_PREFIX}/goods-service/api/v1/goods/interior-evaluations/${req.siteId}/processes/${req.processId}`,
      },
    );
  }
}

export class PutProcessReviewWriteInfoGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: PutProcessReviewWriteInfoGatewayRequest) {
    return await this.httpClient.request<GetProcessReviewWriteInfoGatewayResponse>(
      {
        method: 'PUT',
        url: `${process.env.NEXT_PUBLIC_BASE_API_URL}${process.env.NEXT_PUBLIC_GW_PATH_PREFIX}/goods-service/api/v1/goods/interior-evaluations/${req.siteId}/processes/${req.processId}`,
        body: _.omit(req, ['siteId', 'processId']),
      },
    );
  }
}

export class DeleteProcessReviewImageGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: DeleteProcessReviewImageGatewayRequest) {
    return await this.httpClient.request<DeleteProcessReviewImageGatewayResponse>(
      {
        method: 'DELETE',
        url: `${process.env.NEXT_PUBLIC_BASE_API_URL}${process.env.NEXT_PUBLIC_GW_PATH_PREFIX}/goods-service/api/v1/goods/interior-evaluations/${req.siteId}/processes/${req.processId}/images/${req.intEvalProcImgId}`,
      },
    );
  }
}

// 공통 후기 조회
export class GetSiteReviewWriteInfoGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: GetSiteReviewWriteInfoGatewayRequest) {
    return await this.httpClient.request<GetSiteReviewWriteInfoGatewayResponse>(
      {
        method: 'GET',
        url: `${process.env.NEXT_PUBLIC_BASE_API_URL}${process.env.NEXT_PUBLIC_GW_PATH_PREFIX}/goods-service/api/v1/goods/interior-evaluations/${req.siteId}/common`,
      },
    );
  }
}

// 공통 후기 작성/수정
export class PutSiteReviewWriteInfoGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: PutSiteReviewWriteInfoGatewayRequest) {
    return await this.httpClient.request<GetSiteReviewWriteInfoGatewayResponse>(
      {
        method: 'PUT',
        url: `${process.env.NEXT_PUBLIC_BASE_API_URL}${process.env.NEXT_PUBLIC_GW_PATH_PREFIX}/goods-service/api/v1/goods/interior-evaluations/${req.siteId}/common`,
        body: _.omit(req, ['siteId']),
      },
    );
  }
}
